import { useGetOrganisationCrmList } from "@/features/crm/hooks/useQuery/useGetOrganisationCrmList"
import { useCrmConfigsByCrmProjectId } from "@/features/crm_config/hooks/useQuery/useCrmConfigsByCrmProjectId"
import { Tables } from "@/lib/supabase/supabase_types_override"
import { useGetCrmProjectsByCrmId } from "@/features/crm_project/hooks/useQuery/useGetCrmProjectsByCrmId"
import { createContext, ReactNode, useContext } from "react"

export enum ManageOrganizationTabs {
    crm = 'crm',
    crm_project = 'crm_project',
    crm_config = 'crm_config'
}

export enum ManageOrganizationSecondaryTabs {
    settings = 'settings',
    parameters = 'parameters',
    parameter_editor = 'parameter_editor',
    connections = 'connections',
}

type ManageOrganizationContextProps = {
    crm?: Tables<'crm'> | null
    crmId?: number | null
    setCrm: (crm: Tables<'crm'> | null) => void
    crmProject?: Tables<'crm_project'> | null
    crmProjectId?: number | null
    setCrmProject: (crmProject: Tables<'crm_project'> | null) => void
    crmConfig?: Tables<'crm_config'> | null
    crmConfigId?: number | null
    setCrmConfig: (crmConfig: Tables<'crm_config'> | null) => void
    currentTab: ManageOrganizationTabs
    secondaryTab: ManageOrganizationSecondaryTabs
    setCurrentTab: (currentTab: ManageOrganizationTabs) => void
    setSecondaryTab: (secondaryTab: ManageOrganizationSecondaryTabs) => void
    crmsData?: ReturnType<typeof useGetOrganisationCrmList>
    crmProjectsData?: ReturnType<typeof useGetCrmProjectsByCrmId>
    crmConfigsData?: ReturnType<typeof useCrmConfigsByCrmProjectId>
    aboveLayout?: ReactNode
    setAboveLayout: (aboveLayout: ReactNode) => void
}

export const manageOrganizationContext = createContext<ManageOrganizationContextProps>({
    setCrm: () => {},
    setCrmProject: () => {},
    setCrmConfig: () => {},
    setCurrentTab: () => {},
    setSecondaryTab: () => {},
    setAboveLayout: () => {},
    currentTab: ManageOrganizationTabs.crm,
    secondaryTab: ManageOrganizationSecondaryTabs.settings,
    crmId: null,
    crmProjectId: null,
})

export function useManageOrganizationContext() {
    const ctx = useContext(manageOrganizationContext)
    if (!ctx) throw new Error('useManageOrganizationContext must be used within ManageOrganizationContextProvider')
    return ctx
}
